export function ppn(state) {
  return state.ppn;
}
